module.exports = __webpack_public_path__ + "static/media/selected.3360c5e6.svg";